export default __webpack_public_path__ + "static/media/speaker-carlos-santana.585a060e.jpg";